import { useJobStory } from './hooks/useJobStory';
import styled from 'styled-components6';
import { H5 } from '../../theme';
import { JobCard } from '../JobList';

const SimilarJobsContainer = styled.div`
    flex: 2;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--rwl-spacing-md);
    container-type: inline-size;
    margin-bottom: var(--rwl-spacing-md);
`;

export const SimilarJobs = () => {
    const { similarJobs, setJobStoryId } = useJobStory();

    if (similarJobs === undefined || similarJobs.length === 0) {
        return null;
    }

    return (
        <SimilarJobsContainer className={'similarJobs'}>
            <H5>Similar Jobs</H5>
            {similarJobs.map((job) => {
                return (
                    <JobCard
                        similarJobClass={'similarJob'}
                        onJobCardClicked={() => setJobStoryId(job.id)}
                        key={job.id}
                        job={job}
                        smallMode={true}
                    />
                );
            })}
        </SimilarJobsContainer>
    );
};
